var _polyline, _path, _polyline2, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNtnuLogoBlackNoSlogan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "170.21px",
    height: "33.053px",
    viewBox: "0 0 170.21 33.053",
    style: {
      enableBackground: "new 0 0 170.21 33.053"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00509E"
    },
    d: "M24.697,0.914H8.957c-4.345,0-7.866,3.521-7.866,7.865v15.741c0,4.343,3.521,7.866,7.866,7.866    h15.74c4.343,0,7.866-3.523,7.866-7.866V8.779C32.563,4.435,29.04,0.914,24.697,0.914L24.697,0.914z M8.957,8.779h15.74v15.742    H8.957V8.779L8.957,8.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00509E"
    },
    d: "M16.775,10.142c-3.566,0-6.456,2.891-6.456,6.456c0,3.566,2.89,6.456,6.456,6.456    c3.565,0,6.454-2.89,6.454-6.456C23.229,13.033,20.34,10.142,16.775,10.142"
  }), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "49.677,0.946 65.006,23.228 65.006,6.084 64.961,2.009 60.354,2.009 60.354,0.946 70.233,0.946 70.233,2.009     66.423,2.009 66.378,6.084 66.378,32.619 65.67,32.842 45.115,2.939 45.115,26.95 45.159,31.157 49.899,31.157 49.899,32.221     39.666,32.221 39.666,31.157 43.743,31.157 43.786,26.95 43.786,6.084 43.743,2.009 39.666,2.009 39.666,0.946 49.677,0.946   "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.799,0.946v10.01H99.47c-0.131-1.55-0.307-3.499-1.684-5.802c-1.592-2.702-3.764-2.835-5.89-2.924h-2.483L89.37,6.217    V26.64l0.044,4.518h4.785v1.064h-14.53v-1.064h4.784l0.045-4.518V6.217L84.453,2.23h-2.037c-2.569,0.044-4.519,0.044-6.379,3.013    c-1.461,2.348-1.595,4.208-1.685,5.713h-1.284V0.946H100.799"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "113.38,0.946 128.709,23.228 128.709,6.084 128.663,2.009 124.057,2.009 124.057,0.946 133.937,0.946     133.937,2.009 130.125,2.009 130.081,6.084 130.081,32.619 129.373,32.842 108.818,2.939 108.818,26.95 108.861,31.157     113.602,31.157 113.602,32.221 103.369,32.221 103.369,31.157 107.445,31.157 107.489,26.95 107.489,6.084 107.445,2.009     103.369,2.009 103.369,0.946 113.38,0.946   "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.136,0.946v1.063h-4.385l-0.045,3.764v16.923c0.045,4.384,0.133,8.549,8.374,8.549c8.327,0,8.858-3.632,8.991-7.575    V5.773l-0.044-3.764h-4.475V0.946h9.79v1.063h-3.852l-0.045,3.764v16.126c-0.047,5.803-0.09,10.764-11.565,10.764    c-1.636,0-5.535-0.175-8.017-1.195c-3.942-1.684-4.03-5.139-4.075-9.391V5.773l-0.044-3.764h-3.81V0.946H151.136"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNtnuLogoBlackNoSlogan);
export default __webpack_public_path__ + "static/media/ntnu-logo-black-no-slogan.a824c5a5.svg";
export { ForwardRef as ReactComponent };